module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp3_3009.502fbad5.png";